import { useMutation } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { AnonymousAuthResponse } from "../types/domain";

export function useAnonymousAuth() {
  return useMutation<AnonymousAuthResponse["data"], Error, void>({
    mutationFn: async () => {
      return api<AnonymousAuthResponse["data"]>("/auth/anonymous", {
        method: "POST",
        body: {},
      });
    },
  });
}
